<template>
  <dropdown
    v-model="activeColor"
    class="c-product-color-picker"
    placeholder="Select a Color"
    :options="colorOptions"
  />
</template>

<script>
import ProductColors from '../../mixins/productColors'
import Dropdown from '../dropdown/Dropdown'
import get from 'lodash/get'
export default {
  components: {
    Dropdown
  },
  mixins: [
    ProductColors
  ],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    products: {
      type: Array,
      default: () => []
    },
    renderLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    activeColor: {
      get() {
        const product = this.product
        return get(product, 'handle')
      },
      set(value) {
        this.$emit('select', value)
      }
    },
    colorOptions() {
      const productColors = this.productColors
      let result = []
      for (let color of productColors) {
        result.push({
          label: color.name,
          value: color.handle
        })
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.c-product-color-picker {
  width: 100%;
}

</style>
